module.exports = __webpack_public_path__ + "static/media/Path.386dfba3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Path.svg
// module id = 360
// module chunks = 25